"use client";
import { PaperComponent } from "@/components";
import ListView from "@/components/ListView";
import { CurrencyConverter, IMAGES, WEB_COLORS } from "@/lib/constants";
import Navbar from "@/screens/terms-conditions/Navbar";
import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import CustomDivider from "../component/custom-divider-component";

function createData(benefit, natural_death, accidental_death) {
  return { benefit, natural_death, accidental_death };
}

const rows = [
  createData("Claim Form", true, true),
  createData(
    "Member Information/ Enrollment Form (only for lender-borrower)",
    true,
    true,
  ),
  createData("Death Certificate", true, true),
  createData("Nominee NEFT Details", true, true),
  createData("Current & Past medical records", true, true),
  createData("Police Records (FIR, Panchnama. etc).", "", true),
  createData("Post Mortem report from hospital", "", true),
];

const reasonsToChoosePlan = [
  `Comprehensive benefit to protect your family from financial burden in the event of death.`,
  `In case of unfortunate event, HDFC GCPP helps in paying of outstanding loan to the lending institution as per amortization schedule.`,
  `Insurance covers upto 125% of the loan amount.`,
  `Provides risk cover to protect family from loan liabilities.`,
  `Higher non-medical limits`,
  `Both applicant and co-applicant can be covered in the policy.`,
  `Tax rebate under section 80C and no tax applicable on death claim proceeds.`,
  `Easy to buy through a simple member enrollment form`,
  `Single premium product`,
  `Surrender is allowed only when loan is fully paid.`,
];

const importantNote = [
  `Validate death certificate issued by Municipal AuthoriAuthority will only be accepted (issued under sec 12/ 17).`,
  `Doctor certificate issued on death of the member and cause of death.`,
];

const hdfcCards = [
  {
    icon: IMAGES.loanCoverage,
    label: "Loan Coverage",
    subLabel: "In case of death or diseases",
  },
  { icon: IMAGES.walletCard, label: "Paid EMIs", subLabel: "covered" },
  {
    icon: IMAGES.loanSettled,
    label: "Loan Settled",
    subLabel: "Hero FinCorp settles pending amount.",
  },
  {
    icon: IMAGES.burdenFreeIcon,
    label: "Stay Burden Free",
    subLabel: "Family stays 100% burden-free",
  },
];

const HdfcLifePlan = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Navbar />
      <Container maxWidth="lg" sx={{ padding: { xs: 2, md: 4 } }}>
        <Grid
          container
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={"stretch"}
          bgcolor={"#005E9C"}
          p={{ xs: 2, md: 4 }}
          color={"#ffffff"}
          borderRadius={"24px"}
          mb={4}
          textAlign={"left"}
          // spacing={2}
        >
          <Grid item md={6}>
            <Image
              src={IMAGES.hdfcLifeInsuranceLogo}
              alt="hdfc-icon"
              width={isMobile ? 75 : 125}
            />
            <Typography
              mt={2}
              fontWeight={500}
              fontSize={{ xs: "24px", md: "44px" }}
              // width={{ md: "80%" }}
              textTransform={"capitalize"}
            >
              Protect your family from loan debt
            </Typography>
            <Typography
              fontWeight={400}
              fontSize={{ xs: "12px", md: "16px" }}
              width={{ md: "80%" }}
              lineHeight={"24px"}
              mt={2}
            >
              Secure your loan with HDFC Life Insurance – Loan Protect Cover. In
              case of an unfortunate event, the policy covers the outstanding
              loan, and any remaining amount is paid to your nominee — ensuring
              complete peace of mind for your loved ones.
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            mt={1}
            md={6}
          >
            {hdfcCards?.map((card, index) => (
              <Grid key={index} item xs={6} md={6}>
                <Grid
                  container
                  flexDirection={{ xs: "row", md: "column" }}
                  alignItems={{ xs: "center", md: "center" }}
                  justifyContent={{ md: "center" }}
                  columnGap={1}
                  rowGap={1}
                  wrap="nowrap"
                  sx={{
                    bgcolor: { md: "#277EB7" },
                    p: { md: 2 },
                    borderRadius: { sm: "20px" },
                    height: { xs: "100%", md: "185px" },
                    width: "100%",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  <Grid item>
                    <Image
                      src={card.icon}
                      alt={`icon-${index}`}
                      width={isMobile ? 30 : 40}
                    />
                  </Grid>

                  <Grid item textAlign={{ md: "center", xs: "left" }}>
                    <Typography
                      fontWeight={500}
                      fontSize={{ xs: "12px", md: "16px" }}
                    >
                      {card?.label}
                    </Typography>
                    <Typography
                      fontWeight={350}
                      fontSize={{ xs: "10px", md: "14px" }}
                    >
                      {card?.subLabel}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            {isMobile ? "Salient Features" : "Benefits"}
          </Typography>
        </CustomDivider>
        <PaperComponent
          noDrop
          paperStyle={{
            backgroundColor: "#F2F7F799",
            border: "1px solid #E5F1F1",
          }}
        >
          <Typography
            color={WEB_COLORS.fadeColor}
            textAlign={"left"}
            fontWeight={{ xs: 500, md: 700 }}
            fontSize={{ xs: "16px", md: "32px" }}
          >
            Why choose this plan?
          </Typography>
          <Box ml={2} mt={2}>
            <ListView
              items={reasonsToChoosePlan}
              style={{
                fontSize: isMobile ? "12px" : "16px",
                fontWeight: 400,
                color: "#3F3F3FCC",
                lineHeight: isMobile ? "150%" : "24px",
              }}
              listType={"ordered"}
            />
          </Box>
        </PaperComponent>
        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            Mandatory Documents Required
          </Typography>
        </CustomDivider>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ marginTop: 4, marginBottom: 4 }}
        >
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#E5F1F1" }}>
                <TableCell
                  sx={{
                    fontSize: { xs: "8px", md: "20px" },
                    color: WEB_COLORS.darkTeal,
                    border: "1px solid #F0F0F0",
                    borderRight: "1px solid #72727299",
                  }}
                >
                  Documents (in case of claim)
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: { xs: "8px", md: "20px" },
                    color: WEB_COLORS.darkTeal,
                    border: "1px solid #F0F0F0",
                    borderRight: "1px solid #72727299",
                    textAlign: "center",
                  }}
                >
                  Natural Death
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: { xs: "8px", md: "20px" },
                    color: WEB_COLORS.darkTeal,
                    border: "1px solid #F0F0F0",
                    // borderRight: "1px solid #72727299",
                  }}
                >
                  Accidental Death
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <TableRow
                  key={row.benefit}
                  sx={{
                    backgroundColor: "#F2F7F799",
                    // borderBottom: "1px solid #72727299",
                    "&:last-child td": {
                      borderBottom: "1px solid #F0F0F0 !important",
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: 400,
                      fontSize: { xs: "10px", md: "16px" },
                      color: WEB_COLORS.darkTeal,
                      border: "1px solid #F0F0F0",
                      borderRight: "1px solid #72727299",
                      borderBottom: "1px solid #72727299",
                    }}
                  >
                    {row.benefit}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: { xs: "10px", md: "16px" },
                      color: WEB_COLORS.darkTeal,
                      textAlign: "center",
                      border: "1px solid #F0F0F0",
                      borderRight: "1px solid #72727299",
                      borderBottom: "1px solid #72727299",
                    }}
                  >
                    {row.natural_death ? (
                      <Image
                        src={IMAGES.check}
                        alt="check-icon"
                        width={isMobile ? 15 : 20}
                      />
                    ) : null}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: { xs: "10px", md: "16px" },
                      color: WEB_COLORS.darkTeal,
                      textAlign: "center",
                      border: "1px solid #F0F0F0",
                      borderBottom: "1px solid #72727299",
                    }}
                  >
                    {row.accidental_death ? (
                      <Image
                        src={IMAGES.check}
                        alt="check-icon"
                        width={isMobile ? 15 : 20}
                      />
                    ) : null}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <CustomDivider
          color="#72727299"
          margin={isMobile ? "20px 0" : "20px 0"}
        >
          <Typography
            fontWeight={400}
            fontSize={{ xs: "12px", md: "24px" }}
            color={"#72727299"}
            mr={"12px"}
            textTransform={"uppercase"}
          >
            Important Note
          </Typography>
        </CustomDivider>
        <Box ml={2} mt={2} mb={8}>
          <ListView
            items={importantNote}
            style={{
              fontSize: isMobile ? "12px" : "16px",
              fontWeight: 400,
              color: "#3F3F3FCC",
              lineHeight: isMobile ? "150%" : "24px",
            }}
          />
        </Box>
      </Container>
    </>
  );
};

export default HdfcLifePlan;
